/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getNameClient } from './../../helpers/nameClient';
import './users-list.scss';

import { Card, Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { activeUser, getInactiveUsersList } from '../../store/actions';
//redux
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';

import FormUsers from './form-Users';

import usePageTitle from '../../common/hooks/usePageTitle';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';
import moment from 'moment';

const InactiveUsers = (props: any) => {
    const { inactiveUsers, isLoading } = useSelector((state: any) => state.InactiveUsersReduce);
    const PageTitleInactiveUsers = usePageTitle(props.location.pathname);

    const [dataInactiveUsers, setdataInactiveUsers] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const groupName = 'inactiveUsersViewList';

    const dispatch = useDispatch();

    const initialArrayTable = [
        {
            text: 'Name',
            dataField: 'USUARIO_NOMBRE',
            sort: false,
            // formatter: (cellContent: any, itemDef: any) => <>{itemDef.CreatedOn}</>,
        },
        {
            text: 'Surname',
            dataField: 'USUARIO_APELLIDO',
            sort: true,
            // formatter: (cellContent: any, itemDef: any) => <>{itemDef.PartNumber}</>,
        },
        {
            text: 'Email',
            dataField: 'USUARIO_CORREO',
            sort: true,
            // formatter: (cellContent: any, itemDef: any) => <>{itemDef.Description}</>,
        },
        {
            text: 'Cutomer Key',
            dataField: 'INNOBOKEY',
            sort: true,
            // formatter: (cellContent: any, itemDef: any) => <>{itemDef.Description}</>,
        },
        {
            text: 'Created at',
            dataField: 'createdAt',
            formatter: (cellContent: any, users: any) => <>{moment(users.createdAt).format("YYYY-MM-DD HH:mm:ss")}</>,
            sort: true,
        },
        {
            text: 'Updated at',
            dataField: 'updatedAt',
            formatter: (cellContent: any, users: any) => <>{moment(users.updatedAt).format("YYYY-MM-DD HH:mm:ss")}</>,
            sort: true,
        },
    ];

    useEffect(() => {
        dispatch(getInactiveUsersList());
    }, []);

    useEffect(() => {
        setdataInactiveUsers(inactiveUsers);
    }, [inactiveUsers]);

    useEffect(() => {}, [inactiveUsers]);

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleUpdateUsers = (entities: any) => {
        dispatch(activeUser({ entities, data: selectedRow }));
        Swal.fire({
            icon: 'success',
            title: 'Saved!!!',
            text: 'This user is now active!!!',
        }).then(() => {
            setpopUpState(!popUpState);
        });
    };

    const handleActivate = (user: any) => {
        Swal.fire({
            title: 'Do you want to activate the user?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'Cancel',
            allowEscapeKey: false,
            allowOutsideClick: false,
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(activeUser(user));
                Swal.fire('Saved!', '', 'success');
            }
        });
    };


    return (
        <React.Fragment>
            <div id="main">
                {/* <div id="menuColumn"></div> */}
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>
                            {PageTitleInactiveUsers.replace(/-/g, ' ')} | {getNameClient()}
                        </title>
                    </PageTitle>
                    <Container fluid>
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <div className="container">
                                        <Iloading  loading={isLoading}/>
                                    </div>
                                    {dataInactiveUsers.length > 0 ? (
                                        <ITable
                                            enableDownload={false}
                                            data={inactiveUsers}
                                            fields={initialArrayTable}
                                            tableColumns={initialArrayTable}
                                            headerColorT={'bg-primary text-white'}
                                            actionOnRowClick={handleActionOnRowClick}
                                            handlePopUpState={onPopUpState}
                                            /* actionOnRowClick={(data: any) =>
                        handleActivate(data)
                      } */
                                            // iconPop={'list'}
                                            groupName={groupName}
                                        />
                                    ) : null}
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                modalTitleAdd={'Active User and Entity assignment'}
                icon="user-check"
                colorHeaderPop={'#101340'}
            >
                <FormUsers selectedEntities={selectedRow} onUpdateUser={handleUpdateUsers} onCancel={onPopUpState} />
            </IPopUp>
        </React.Fragment>
    );
};

export default InactiveUsers;
